import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    // base: process.env.BASE_URL, siteCode 是各个站点的 给后台传的值
    routes: [
        /*{
            path: '/:siteCode',
            name: 'home',
            redirect: '/:siteCode/backStage/infoPrice',
        },*/
        {
            path: '/:siteCode/homePage',
            name: 'homePage',
            component: () => import('./views/homePage/index.vue'),
        },
        // 采编审 - 工程造价管理平台
        {
          path: '/:siteCode/toInfoSearch',
          name: 'ToInfoSearch',
          component: () => import('./views/ToInfoSearch/index.vue'),
        },
        // 采编审 -  柱状图
        {
          path: '/:siteCode/toInfoSearch/barchart',
          name: 'barchart',
          component: () => import('./views/ToInfoSearch/barChart.vue'),
        },
        // 采编审 -  折线图
        {
          path: '/:siteCode/toInfoSearch/linechart',
          name: 'linechart',
          component: () => import('./views/ToInfoSearch/lineChart.vue'),
        },
        // 采编审 -  历史数据
        {
            path: '/toInfoSearch/historyPrice',
            name: 'historyPrice',
            component: () => import('./views/ToInfoSearch/historyPrice.vue'),
        },
        //大屏
        {
            path: '/:siteCode/bigScreen',
            name: 'bigScreen',
            component: () => import('./views/bigScreen/index.vue'),
        },
        //后台每日价格
        {
            path: '/:siteCode/backStage/dayPrice',
            name: 'dayPrice',
            component: () => import('./views/backStage/dayPrice/index.vue'),
        },
        //后台趋势图
        {
            path: '/:siteCode/backStage/dayCharts',
            name: 'dayCharts',
            component: () => import('./views/backStage/dayCharts/index.vue'),
        },
        //后台指数
        {
            path: '/:siteCode/backStage/priceIndex',
            name: 'priceIndex',
            component: () => import('./views/backStage/priceIndex/index.vue'),
        },
        //后台价格预测
        {
            path: '/:siteCode/backStage/priceForecast',
            name: 'priceForecast',
            component: () => import('./views/backStage/priceForecast/index.vue'),
        },
        //后台信息价动态
        {
            path: '/:siteCode/backStage/infoPrice',
            name: 'infoPrice',
            component: () => import('./views/backStage/infoPrice/index.vue'),
        },
        //监测异动预警
        {
            path: '/:siteCode/backStage/monitorHome',
            name: 'infoPrice',
            component: () => import('./views/backStage/monitorHome/index.vue'),
        },
        //后台报告
        {
            path: '/:siteCode/backStage/report',
            name: 'report',
            component: () => import('./views/backStage/report/index.vue'),
        },
        //后台报告
        {
            path: '/:siteCode/backStage/marketPrice',
            name: 'marketPrice',
            component: () => import('./views/backStage/marketPrice/index.vue'),
        },
        {
            path: '/:siteCode/backStage/moveWarning',
            name: 'moveWarning',
            component: () => import('./views/backStage/moveWarning/index.vue'),
        },
        {
            path: '/:siteCode/backStage/monitorPerformance',
            name: 'monitorPerformance',
            component: () => import('./views/backStage/monitorPerformance/index.vue'),
        },
        {
            path: '/gangcai',
            name: 'gangcai',
            redirect: '/gangcai/price',
            component: () => import('./views/Gangcai/index.vue'),
            children: [
                {
                    path: 'charts',
                    name: 'charts',
                    component: () => import('./views/SubPages/gcCharts/index.vue')
                },
                {
                    path: 'dynamic',
                    name: 'dynamic',
                    component: () => import('./views/SubPages/Dynamic/index.vue')
                },
                {
                    path: 'forecast',
                    name: 'forecast',
                    component: () => import('./views/SubPages/Forecast/index.vue')
                },
                {
                    path: 'indexNum',
                    name: 'indexNum',
                    component: () => import('./views/SubPages/gcIndexNum/index.vue')
                },
                {
                    path: 'price',
                    name: 'price',
                    component: () => import('./views/SubPages/gcPrice/index.vue')
                },
                {
                    path: 'marketPrice',
                    name: 'marketPrice',
                    component: () => import('./views/SubPages/marketPrice/index.vue')
                },
            ]
        },
        {
            path: '/hunningtu',
            name: 'hunningtu',
            redirect: '/hunningtu/price',
            component: () => import('./views/Hunningtu/index.vue'),
            children: [
                {
                    path: 'charts',
                    name: 'hntcharts',
                    component: () => import('./views/SubPages/hntCharts/index.vue')
                },
                {
                    path: 'dynamic',
                    name: 'dynamic',
                    component: () => import('./views/SubPages/Dynamic/index.vue')
                },
                {
                    path: 'forecast',
                    name: 'forecast',
                    component: () => import('./views/SubPages/Forecast/index.vue')
                },
                {
                    path: 'indexNum',
                    name: 'indexNum',
                    component: () => import('./views/SubPages/hntIndexNum/index.vue')
                },
                {
                    path: 'price',
                    name: 'price',
                    component: () => import('./views/SubPages/hntPrice/index.vue')
                },
                {
                    path: 'marketPrice',
                    name: 'marketPrice',
                    component: () => import('./views/SubPages/marketPrice/index.vue')
                },
            ]
        },
        {
            path: '/shashi',
            name: 'shashi',
            redirect: '/shashi/price',
            component: () => import('./views/Shashi/index.vue'),
            children: [
                {
                    path: 'charts',
                    name: 'sscharts',
                    component: () => import('./views/SubPages/ssCharts/index.vue')
                },
                {
                    path: 'dynamic',
                    name: 'dynamic',
                    component: () => import('./views/SubPages/Dynamic/index.vue')
                },
                {
                    path: 'forecast',
                    name: 'forecast',
                    component: () => import('./views/SubPages/Forecast/index.vue')
                },
                {
                    path: 'indexNum',
                    name: 'indexNum',
                    component: () => import('./views/SubPages/ssIndexNum/index.vue')
                },
                {
                    path: 'price',
                    name: 'price',
                    component: () => import('./views/SubPages/ssPrice/index.vue')
                },
                {
                    path: 'marketPrice',
                    name: 'marketPrice',
                    component: () => import('./views/SubPages/marketPrice/index.vue')
                },
            ]
        },
        {
            path: '/shuini',
            name: 'shuini',
            redirect: '/shuini/price',
            component: () => import('./views/Shuini/index.vue'),
            children: [
                {
                    path: 'charts',
                    name: 'sncharts',
                    component: () => import('./views/SubPages/snCharts/index.vue')
                },
                {
                    path: 'dynamic',
                    name: 'dynamic',
                    component: () => import('./views/SubPages/Dynamic/index.vue')
                },
                {
                    path: 'forecast',
                    name: 'forecast',
                    component: () => import('./views/SubPages/Forecast/index.vue')
                },
                {
                    path: 'indexNum',
                    name: 'indexNum',
                    component: () => import('./views/SubPages/snIndexNum/index.vue')
                },
                {
                    path: 'price',
                    name: 'price',
                    component: () => import('./views/SubPages/snPrice/index.vue')
                },
                {
                    path: 'marketPrice',
                    name: 'marketPrice',
                    component: () => import('./views/SubPages/marketPrice/index.vue')
                },
            ]
        },
        {
            path: '/priceCompare/:gcFlag/:compareArr',
            name: 'priceCompare',
            component: () => import('./views/SubPages/priceCompare/index.vue')
        },
        {
            path: '/article1',
            name: 'article1',
            component: () => import('./views/SubPages/article1/index.vue')
        },
        {
            path: '/article2',
            name: 'article2',
            component: () => import('./views/SubPages/article2/index.vue')
        },
        {
            path: '/article3',
            name: 'article3',
            component: () => import('./views/SubPages/article3/index.vue')
        },
        {
            path: '/article4',
            name: 'article4',
            component: () => import('./views/SubPages/article4/index.vue')
        },
        {
            path: '/reportDetail',
            name: 'reportDetail',
            component: () => import('./views/SubPages/reportDetail/index.vue')
        },
        {
            path: '/noPage',
            name: 'noPage',
            component: () => import('./views/noPage/index.vue')
        },
        {path:'*',redirect:'/noPage'},
    ]
})